import React from 'react';
import { useNavigate } from 'react-router-dom';

const OrderConfirmation = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-2xl mx-auto p-6 text-center">
      <div className="bg-green-100 p-6 rounded-lg mb-6">
        <h2 className="text-2xl font-bold text-green-800 mb-4">
          Thank you for your order!
        </h2>
        <p className="text-green-700 mb-4">
          Your payment has been processed successfully.
        </p>
      </div>
      
      <button 
        onClick={() => navigate('/shop')} 
        className="btn btn-primary"
      >
        Continue Shopping
      </button>
    </div>
  );
};

export default OrderConfirmation;